type getCurrentPageFromPaginationProps = {
  offset: number
  limit: number
}

export const getCurrentPageFromPagination = ({
  offset,
  limit,
}: getCurrentPageFromPaginationProps) => (offset === 0 && limit === 0 ? 0 : offset / limit) + 1
